import useApiFetch from '@/hooks/useApiFetch';
import interviewsServices from '@/services/interviews';
import { FetchApiIds, ValuesWithLabel } from '@/types';
import ChallengeTypeInputComponent, {
  ChallengeTypeInputComponentProps,
} from './ChallengeTypeInput.component';

export type ChallengeTypeInputType = Pick<
  ChallengeTypeInputComponentProps,
  'value' | 'onChangeDropDown' | 'isDisabled' | 'languageUsedByCandidate' | 'onChangeLanguageUsed'
>;

export const CHALLENGE_TYPE_INPUT_PLACEHOLDER = 'Select an option';

export default function ChallengeTypeInput({
  value,
  onChangeDropDown,
  isDisabled,
  languageUsedByCandidate,
  onChangeLanguageUsed,
}: ChallengeTypeInputType): JSX.Element {
  const technicalChallengesResponse = useApiFetch(
    FetchApiIds.TECHNICAL_CHALLENGES,
    interviewsServices.getTechnicalChallenges
  );

  const technicalChallenges = [
    {
      value: CHALLENGE_TYPE_INPUT_PLACEHOLDER,
      label: CHALLENGE_TYPE_INPUT_PLACEHOLDER,
    },
    ...((technicalChallengesResponse.data ?? [])
      .map((challenge) => {
        if (!challenge.isActive) return null;
        return {
          value: challenge.id,
          label: challenge.name,
        };
      })
      .filter(Boolean) as ValuesWithLabel[]),
  ];

  const valueLabel =
    technicalChallenges.find((challenge) => challenge.value === value)?.label ?? '';

  return (
    <ChallengeTypeInputComponent
      languageUsedByCandidate={languageUsedByCandidate}
      onChangeLanguageUsed={onChangeLanguageUsed}
      isDisabled={isDisabled}
      options={technicalChallenges}
      value={valueLabel}
      onChangeDropDown={onChangeDropDown}
    />
  );
}
